import { checkPrerequisites } from './analytics';
import { isDevelopment } from '@/utils/env';

import mixpanel from 'mixpanel-browser';

// Publishable key — safe to commit, not a secret
const MIXPANEL_PUBLISHABLE_KEY = '4e7ae9a9ac2dc65370bd122935e79da4';

export function initMixpanel() {
  mixpanel.init(MIXPANEL_PUBLISHABLE_KEY, {
    debug: isDevelopment(),
    track_pageview: true,
    ignore_dnt: true,
    persistence: 'localStorage',
    api_host: 'https://api-eu.mixpanel.com',
  });
}
